import './StandardDateSelector.css';
import React from 'react';

const errorBorderStyle = {
  border: '3px solid red',
  borderRadius: '6px',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  fontFamily: 'Verdana, Geneva, sans-serif',
  color: '#666666',
};

const normalBorderStyle = {
  border: 'none',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  fontFamily: 'Verdana, Geneva, sans-serif',
  color: '#666666',
};

export function StandardDateSelector({
  title,
  setData,
  allowPast = true,
  onError = false,
  onErrorSet = () => {}, // Default to a no-op function
  errorText = '',
  errorTextSet = () => {}, // Default to a no-op function
  onChangeFunction = null,
}) {
  const currentDate = new Date().toISOString().split('T')[0]; // Format date to YYYY-MM-DD

  const handleValueChange = (event) => {
    const selectedDate = event.target.value;
    const isPastDate = !allowPast && Date.parse(selectedDate) < Date.parse(currentDate);

    // Validate date
    if (isPastDate) {
      onErrorSet(true);
      errorTextSet('Required date cannot be in the past');
    } else {
      onErrorSet(false);
      errorTextSet('');
      setData(selectedDate);
    }

    // Call additional onChangeFunction if provided
    if (onChangeFunction) {
      onChangeFunction(selectedDate);
    }
  };

  return (
    <div className="sdsFormRow">
      <div className="sdsTitleDiv">
        <label className="sdsTitleLabel">{title}</label>
      </div>
      <div className="sdsInputDiv">
        <input
          style={onError ? errorBorderStyle : normalBorderStyle}
          className="dateSelector"
          id="datePicker"
          type="date"
          min={allowPast ? null : currentDate} // Disable past dates if not allowed
          onChange={handleValueChange}
        />
        <label className="sdsErrorLabel">{errorText}</label>
      </div>
    </div>
  );
}
